import { useState, useEffect } from "react";
import { Select, Button } from "antd";
import useMembersStore from "../../store/members.store";
import {
  UndoOutlined,
  FilterOutlined,
  DownCircleOutlined,
  UpCircleOutlined,
} from "@ant-design/icons";

import "./TextFilter.scss";

const SELECT_ALL_VALUE = "__SELECT_ALL__";
const SELECT_ALL_OPTION = { label: "Select All", value: SELECT_ALL_VALUE };

const INITIAL_FILTER_STATE = {
  search: "",
  sortBy: "",
  sortOrder: "",
  "Total Experience": "All",
  "Relevant Experience": "All",
  "Current CTC": "All",
  ECTC: "All",
  "Notice Period": "All",
  "Candidate Status": [],
  "Resume Suitability": [],
  "Resume Status": [],
  "Education Analysis": [],
  "Experience Analysis": [],
  "Parsing Errors": [],
  Gender: [],
  "Reason For Leaving": [],
  "Reason For Not Working": [],
  "Other Offers": [],
  Payroll: [],
  "Skill Matrix Suitability": [],
  "Assessment Suitability": [],
  "Interview Status": [],
  "Interview Type": [],
  "Offer Status": [],
  Ownership: [],
  "Source By": [],
  "Updated By": [],
};

export default function TextFilter({
  currentView,
  setCurrentPage,
  globalFilterData,
  setGlobalFilterData,
  config = [],
  lexicalsort,
  defaultFilters = {},
}) {
  const [filterApiParameters, setFilterApiParameters] = useState(
    globalFilterData || INITIAL_FILTER_STATE,
  );

  const [showAll, setShowAll] = useState(false);

  const [currentFiltersToView, setCurrentFiltersToView] = useState([]);

  const getAllOptionValues = (filterKey) => {
    const currentConfig = config.find((item) => item.key === filterKey);
    if (!currentConfig?.options?.length) return [];

    return currentConfig.options
      .map((option) => option?.value)
      .filter((optionValue) => optionValue !== undefined);
  };

  useEffect(() => {
    if (setGlobalFilterData && typeof setGlobalFilterData === "function") {
      setGlobalFilterData(filterApiParameters);
      setCurrentPage(1);
    }
  }, [filterApiParameters]);

  const handleFilterChange = (filterKey, value) => {
    const isMultiSelectValue = Array.isArray(value);

    if (isMultiSelectValue && value.includes(SELECT_ALL_VALUE)) {
      const allOptionValues = getAllOptionValues(filterKey);
      const currentSelectedValues = Array.isArray(
        filterApiParameters[filterKey],
      )
        ? filterApiParameters[filterKey]
        : [];

      const isEverythingSelected =
        allOptionValues.length > 0 &&
        currentSelectedValues.length === allOptionValues.length &&
        allOptionValues.every((optionValue) =>
          currentSelectedValues.includes(optionValue),
        );

      value = isEverythingSelected ? [] : allOptionValues;
    }

    //console.log("filterKey", filterKey, "value", value);
    if (filterKey === "Ownership" && value.includes("Internal")) {
      console.log("Inside if condition filterKey", filterKey, "value", value);

      value = ["By Team"];
    }
    //console.log("after if ", value);
    const tempFilter = { ...globalFilterData, [filterKey]: value };
    setFilterApiParameters(tempFilter);
    if (!currentFiltersToView.includes(currentView)) {
      setCurrentFiltersToView((prev) => [...prev, currentView]);
    }
  };

  const visibleConfig = showAll ? config : config.slice(0, 7);

  return (
    <div className="resumes-fitler-wrapper">
      <div className="resumes-selectable-filter-wrapper">
        {visibleConfig.map((item) => (
          <div className="resumes-selectable-input" key={item.key}>
            <label className="resumes-selectable-filter-label">
              {item.key}
            </label>
            <Select
              className="resumes-selectable-filter"
              placeholder={"All"}
              mode={item.mode || "multiple"}
              options={
                (item.mode || "multiple") === "multiple"
                  ? [SELECT_ALL_OPTION, ...(item.options || [])]
                  : item.options
              }
              value={filterApiParameters[item.key]}
              onChange={(value) => handleFilterChange(item.key, value)}
            />
          </div>
        ))}
        {!showAll && (
          <div className="resumes-selectable-input-show-more">
            <Button
              color="default"
              variant="text"
              style={{
                fontSize: "14px",
                backgroundColor: "rgba(103, 103, 103, 0.05)",
                width: "100%",
              }}
              onClick={() => setShowAll(true)}
            >
              <DownCircleOutlined />
              Show More
            </Button>
          </div>
        )}
      </div>
      <div
        className="resume-filter-bottom-wrapper"
        style={{
          display: "flex",
          justifyContent: showAll ? "space-between" : "end",
        }}
      >
        {showAll && (
          <div className="resume-filter-input-show-less">
            <Button
              color="default"
              variant="text"
              style={{
                fontSize: "14px",
                backgroundColor: "rgba(103, 103, 103, 0.05)",
                width: "100%",
              }}
              onClick={() => setShowAll(false)}
            >
              <UpCircleOutlined />
              Show Less
            </Button>
          </div>
        )}

        <div className="resume-filter-list">
          <div className="resume-filter-list-text">
            {currentFiltersToView.length > 0 && <FilterOutlined />}{" "}
            {currentFiltersToView?.join(", ")}
          </div>
          {lexicalsort}    
          <Button
            className="resumes-selectable-filter-btn"
            onClick={() => {
              setFilterApiParameters(() => ({ ...defaultFilters }));
              setCurrentFiltersToView([]);
            }}
          >
            <UndoOutlined /> Reset All
          </Button>
        </div>
      </div>
    </div>
  );
}
